// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    useGetMemberVPosList,
    useAuthorization,
    useGetAllMerchantList,
    useGetMerchantVPosListOnly
} from "../../../hooks";
import {
    Autocomplete,
    Box,
    FormControl,
    Stack,
    Switch,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { DeleteConfirmModal } from "../../molecules";
import React, { useMemo, useEffect, useState } from "react";
import { Button } from "../../atoms";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { zodResolver } from "@hookform/resolvers/zod";
import {
    merchantAuthFormSchema,
    MerchantAuthFormValuesType,
    merchantAuthInitialValues,
} from "../../../components/organisms/bank/_formTypes";
import { useUserInfo } from "../../../store/User.state";
import { MerchantBankDynamicFieldsModal } from "./MerchantBankDynamicFieldsModal";
import { useMerchantVPosAddWithSettings } from "../../../hooks/merchantVPos/useMerchantVPosAddWithSettings";
import { useGetDefaultVPosSettingsList } from "../../../hooks/default-vpos-settings/useGetDefaultVPosSettingsList";
import { useMerchantVPosDelete } from "../../../hooks/merchantVPos/useMerchantVPosDelete";

export const MerchantBankAuthorizationPage = ({ merchantId: propMerchantId }) => {
    const theme = useTheme();
    const { showCreate } = useAuthorization();
    const [userInfo] = useUserInfo();

    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const { mutate: getMemberVPosList, data: rawMemberVPosList } = useGetMemberVPosList();
    const { mutate: getMerchantVPosList, data: merchantVPosListResponse } = useGetMerchantVPosListOnly();
    const { mutate: updateMerchantVPos, isLoading: isUpdating } = useMerchantVPosAddWithSettings();
    const { mutate: getDefaultSettings, isLoading: isLoadingDefaultSettings } = useGetDefaultVPosSettingsList();
    const { mutate: deleteMerchantVPos, isLoading: isDeleting } = useMerchantVPosDelete();
    const [listData, setListData] = React.useState([]);
    const [authorizedBankMap, setAuthorizedBankMap] = useState<{ [bankCode: string]: any }>({});
    const [selectedMerchantBanks, setSelectedMerchantBanks] = useState<any[]>([]);
    const [currentBankSettings, setCurrentBankSettings] = useState<any[]>([]);
    const [currentBankCode, setCurrentBankCode] = useState<string | null>(null);
    const handleBack = () => navigate("/dashboard");
    const navigate = useNavigate();
    const { data: rawMerchantList, isLoading: isMerchantListLoading } = useGetAllMerchantList("ACTIVE");
    const { control, watch, handleSubmit, setValue, register } =
        useForm<MerchantAuthFormValuesType>({
            resolver: zodResolver(merchantAuthFormSchema),
            defaultValues: merchantAuthInitialValues,
        });
    const setSnackbar = useSetSnackBar();
    const merchantId = watch("merchantId");
    const merchantList = useMemo(() => {
        const activeMerchants = rawMerchantList?.data?.filter(
            (merchant) => merchant?.status === "ACTIVE"
        );


        if (userInfo.merchantId == 0) {
            return activeMerchants?.map(
                (rawPosType: { merchantName: string; merchantId: number }) => {
                    return {
                        label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
                        value: rawPosType.merchantId,
                    };
                }
            );
        } else {
            return activeMerchants
                ?.filter((rawPosType: { merchantName: string; merchantId: number }) => {
                    return rawPosType.merchantId === Number(userInfo.merchantId);
                })
                .map((filteredMerchant) => {
                    return {
                        label: filteredMerchant.merchantName + ` (${rawPosType.merchantId})`,
                        value: filteredMerchant.merchantId,
                    };
                });
        }
    }, [rawMerchantList?.data, userInfo?.merchantId]);

    const [selectedDropdownMerchantId, setSelectedDropdownMerchantId] = useState(0);

    useEffect(() => {
        if (propMerchantId && propMerchantId > 0) {
            setValue("merchantId", propMerchantId);
            setSelectedDropdownMerchantId(propMerchantId);
        }
    }, [propMerchantId, setValue]);

    useEffect(() => {
        getMemberVPosList({
            orderBy: "CreateDate",
            orderByDesc: true,
            status: "ACTIVE",
        });
    }, [getMemberVPosList]);

    useEffect(() => {
        if (rawMemberVPosList?.data) {
            setListData(rawMemberVPosList?.data || []);
        }
    }, [rawMemberVPosList]);

    useEffect(() => {
        if (merchantId) {
            getMerchantVPosList({
                status: "ACTIVE",
                merchantId: merchantId,
                orderBy: "CreateDate",
                orderByDesc: true,
                page: 0,
                size: 25
            }, {
                onSuccess: (response) => {
                    if (response?.data?.result) {
                        const formattedBanks = response.data.result.map(bank => ({
                            ...bank,
                            bankCode: String(bank.bankCode).padStart(4, '0')
                        }));
                        setSelectedMerchantBanks(formattedBanks);
                    }
                }
            });
        } else {
            setSelectedMerchantBanks([]);
        }
    }, [merchantId, getMerchantVPosList]);

    const handleShowEnrollmentDetail = (bankCode: string) => {
        const formattedBankCode = String(bankCode).padStart(4, '0');
        const selectedBank = selectedMerchantBanks.find(bank => bank.bankCode === formattedBankCode);

        if (selectedBank?.merchantVposSettings) {
            const formattedSettings = selectedBank.merchantVposSettings.map(setting => ({
                key: setting.key,
                label: setting.label || setting.key,
                value: setting.value || '',
                required: true
            }));

            setCurrentBankSettings(formattedSettings);
            setCurrentBankCode(formattedBankCode);
            setIsMerchantAuthFormOpen(true);
        }
    };

    const handleSwitchClick = (bankCode: string) => {
        const formattedBankCode = String(bankCode).padStart(4, '0');
        const hasSettings = selectedMerchantBanks.some(bank =>
            bank.bankCode === formattedBankCode && bank.merchantVposSettings?.length > 0
        );

        if (!hasSettings) {
            getDefaultSettings({
                bankCode: formattedBankCode,
                merchantId: merchantId
            }, {
                onSuccess: (response) => {
                    let settings = [];
                    if (response?.data?.defaultVposSetting) {
                        settings = response.data.defaultVposSetting.map(setting => ({
                            key: setting.key,
                            label: setting.key,
                            value: '',
                            required: true
                        }));
                    }
                    setCurrentBankSettings(settings);
                    setCurrentBankCode(formattedBankCode);
                    setIsMerchantAuthFormOpen(true);
                },
                onError: (error) => {
                    setCurrentBankSettings([]);
                    setCurrentBankCode(formattedBankCode);
                    setIsMerchantAuthFormOpen(true);
                    setSnackbar({
                        severity: "error",
                        description: "Banka ayarları alınırken bir hata oluştu"
                    });
                }
            });
        } else {
            setBankToDeactivate(formattedBankCode);
            setIsDeactivateModalOpen(true);
        }
    };

    const handleUpdateSettings = (data: any) => {
        const formattedData = {
            bankCode: String(currentBankCode).padStart(4, '0'),
            merchantID: merchantId,
            parameters: data.parameters,
            defaultBank: false
        };

        updateMerchantVPos(formattedData, {
            onSuccess: () => {
                setSnackbar({
                    severity: "success",
                    description: "Banka başarıyla yetkilendirildi",
                });
                setIsMerchantAuthFormOpen(false);

                getMerchantVPosList({
                    status: "ACTIVE",
                    merchantId: merchantId,
                    orderBy: "CreateDate",
                    orderByDesc: true,
                    page: 0,
                    size: 25
                }, {
                    onSuccess: (response) => {
                        if (response?.data?.result) {
                            const formattedBanks = response.data.result.map(bank => ({
                                ...bank,
                                bankCode: String(bank.bankCode).padStart(4, '0')
                            }));
                            setSelectedMerchantBanks(formattedBanks);
                        }
                    }
                });
            },
            onError: (error: any) => {
                setSnackbar({
                    severity: "error",
                    description: error.message || "Yetkilendirme işlemi başarısız oldu",
                });
            }
        });
    };

    // MARK : Authorization Modal
    const [currentSelectedBank, setCurrentSelectedBank] = useState("");
    const [isMerchantAuthFormOpen, setIsMerchantAuthFormOpen] = useState(false);
    const [isCancelEnrollmentModalOpen, setIsCancelEnrollmentModalOpen] = useState(false);

    const handleMerchantAuthClose = () => {
        setIsMerchantAuthFormOpen(false);
        setShowEnrollmentInfo(false);
    };

    const [showEnrollmentInfo, setShowEnrollmentInfo] = useState(false);

    const [bankToDeactivate, setBankToDeactivate] = useState<string | null>(null);
    const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);

    const handleDeactivateConfirm = () => {
        if (bankToDeactivate) {
            // İlgili bankanın id'sini bul
            const bankToDelete = selectedMerchantBanks.find(bank => bank.bankCode === bankToDeactivate);
            if (bankToDelete?.id) {
                deleteMerchantVPos(
                    { id: bankToDelete.id },
                    {
                        onSuccess: () => {
                            setSnackbar({
                                severity: "success",
                                description: "Yetkilendirme başarıyla iptal edildi",
                            });
                            setIsDeactivateModalOpen(false);
                            setBankToDeactivate(null);
                            // Listeyi güncelle
                            getMerchantVPosList({
                                status: "ACTIVE",
                                merchantId: merchantId,
                                orderBy: "CreateDate",
                                orderByDesc: true,
                                page: 0,
                                size: 25
                            }, {
                                onSuccess: (response) => {
                                    if (response?.data?.result) {
                                        const formattedBanks = response.data.result.map(bank => ({
                                            ...bank,
                                            bankCode: String(bank.bankCode).padStart(4, '0')
                                        }));
                                        setSelectedMerchantBanks(formattedBanks);
                                    }
                                }
                            });
                        },
                        onError: (error: any) => {
                            setSnackbar({
                                severity: "error",
                                description: error.message || "Yetkilendirme iptali başarısız oldu",
                            });
                            setIsDeactivateModalOpen(false);
                            setBankToDeactivate(null);
                        }
                    }
                );
            } else {
                setIsDeactivateModalOpen(false);
                setBankToDeactivate(null);
            }
        } else {
            setIsDeactivateModalOpen(false);
            setBankToDeactivate(null);
        }
    };

    return (<Stack flex={1}>
        <Stack flex={1} p={2}>
            <Stack spacing={4}>
                {!propMerchantId && (
                    <Stack width={isDesktop ? 800 : "auto"} spacing={3} direction="row">
                        <FormControl sx={{ flex: 1 }}>
                            {merchantList && (
                                <Controller
                                    name="merchantId"
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { onChange, value } }) => {
                                        const selectedMerchant = merchantList.find(
                                            (option) => option.value === value
                                        );

                                        return (
                                            <Autocomplete
                                                id="merchantId"
                                                options={merchantList}
                                                getOptionSelected={(option, value) =>
                                                    option.value === value
                                                }
                                                getOptionLabel={(option) => option.label}
                                                value={selectedMerchant || null}
                                                onChange={(_, newValue) => {
                                                    setSelectedDropdownMerchantId(newValue ? newValue.value : 0);
                                                    onChange(newValue ? newValue.value : "");
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="İşyeri" />
                                                )}
                                            />
                                        );
                                    }}
                                />
                            )}
                        </FormControl>
                    </Stack>
                )}
                {isDesktop && <Box sx={{ flex: 1 }} />}
                <Stack direction={isDesktop ? "row" : "column"} flexWrap="wrap">
                    {listData?.map((field: any, index: any) => {
                        // Banka kodunu 4 haneli formata çevir
                        const currentBankCode = String(field.bankCode).padStart(4, '0');

                        const merchantBank = selectedMerchantBanks.find(
                            bank => bank.bankCode === currentBankCode
                        );

                        const hasSettings = merchantBank?.merchantVposSettings?.length > 0;

                        return (
                            <Box
                                my={1}
                                mr={isDesktop ? 3 : 0}
                                flex={isDesktop ? "44%" : "auto"}
                                key={index}
                            >
                                <Stack
                                    py={1}
                                    px={2}
                                    justifyContent="space-between"
                                    alignItems="center"
                                    flex={1}
                                    direction="row"
                                    borderRadius={1}
                                    border={`1px solid ${!merchantId ? "#ADB6C4" : "#c4c4c4"}`}
                                >
                                    <Typography
                                        color={!merchantId ? "#ADB6C4" : "#41414D"}
                                    >{`${currentBankCode}-${field.bankName}`}</Typography>
                                    <Stack justifyContent={'right'} flex={1} direction={'row'}>
                                        <Switch
                                            checked={hasSettings}
                                            disabled={!merchantId}
                                            onChange={() => {
                                                if (merchantId) {
                                                    handleSwitchClick(currentBankCode);
                                                }
                                            }}
                                        />
                                        {hasSettings && merchantId && (
                                            <Button text="Detay" onClick={() => handleShowEnrollmentDetail(currentBankCode)}>
                                                Detay
                                            </Button>
                                        )}
                                    </Stack>
                                </Stack>
                            </Box>
                        );
                    })}
                </Stack>
            </Stack>
        </Stack>
        <Stack
            borderTop="1px solid #E6E9ED"
            py={2}
            direction="row"
            justifyContent="flex-end"
        >
            <Button onClick={handleBack} sx={{ mx: 2 }} text={"Iptal"} />
        </Stack>
        <MerchantBankDynamicFieldsModal
            open={isMerchantAuthFormOpen}
            handleClose={() => {
                setIsMerchantAuthFormOpen(false);
                setCurrentBankSettings([]);
            }}
            fields={currentBankSettings}
            loading={isUpdating || isLoadingDefaultSettings}
            onSubmit={handleUpdateSettings}
            bankCode={currentBankCode}
            isEditing={false}
        />
        <DeleteConfirmModal
            isOpen={isDeactivateModalOpen}
            onClose={() => {
                setIsDeactivateModalOpen(false);
                setBankToDeactivate(null);
            }}
            title="Yetkilendirme İptali"
            content="Yetkilendirme işlemini iptal etmek istediğinize emin misiniz?"
            confirmButtonText="Evet"
            closeButtonText="Hayır"
            onConfirm={handleDeactivateConfirm}
        />
    </Stack>);
};